<template>
    <a-col :span="24">
      <a-row style="padding: 12px 0px 12px 0px; text-align: left;">
        <a-button type="primary" @click="showAddAgent">添加代理商</a-button>
      </a-row>

      <a-row class="content-container">
        <a-row v-for="(user_data, index) in list" :key="index" class="content-item">
          <a-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" style="line-height: 32px; text-align: left;">
            <span><a-icon type="user"/>&nbsp;{{user_data.account}}</span>
          </a-col>
          <a-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" style="line-height: 32px; text-align: left;">
            <span><b>手机号：</b>{{user_data.mobile}}</span>
          </a-col>
          <a-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" style="line-height: 32px; text-align: left;">
            <span><b>余额：</b>{{user_data.balance}}&nbsp;元</span>
          </a-col>
          <a-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" style="line-height: 32px; text-align: left;">
            <b>注册时间：</b>{{user_data.created | timeChange}}
          </a-col>
          <a-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" style="line-height: 32px; text-align: left;">
            <b>更新时间：</b>{{user_data.updated | timeChange}}
          </a-col>
          <a-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" style="text-align: right; line-height: 32px;">
            <span>
              <a style="color: #1890ff" @click="showEditAgent(index)">修改</a>&nbsp;|
              <a style="color: #1890ff" @click="showChargeAgent(index)">充值</a>&nbsp;|
              <a style="color: #1890ff" @click="changeAgentStatus(index)">{{user_data.status | statusChange}}</a>
            </span>
          </a-col>
        </a-row>
      </a-row>

      <a-row v-if="list.length > 0" style="margin-top: 12px;">
        <a-button @click="loadMore">加载更多</a-button>
      </a-row>

      <a-row v-else="">
        <span>没有用户，请添加代理商。</span>
      </a-row>
      
      <a-modal v-model="add_agent" title="添加代理商" :footer="null" :width="modalWidth" @cancel="resetAgent">
        <edit-manager @change="editChange"/>
      </a-modal>
      <a-modal v-model="edit_agent" title="修改代理商" :footer="null" :width="modalWidth" @cancel="resetAgent">
        <edit-manager :uid="uid" @change="editChange"/>
      </a-modal>
      <a-modal v-model="charge_agent" title="充值" :footer="null" :width="modalWidth" @cancel="resetAgent">
        <charge-agent :uid="uid" :balance="balance" @change="editChange"/>
      </a-modal>
    </a-col>
</template>

<script>
import EditManager from './EditManager.vue';
import ChargeAgent from './ChargeAgent.vue';

export default {
  name: 'Manager',
  data() {
    return {
      tab: 'man',
      postdata: {},
      list: [],
      uid: "",
      add_agent: false,
      edit_agent: false,
      charge_agent: false,
      balance: 0,
      charge: 0.0,
      refresh: 0,
      page: 0, 
      modalWidth: "98%", 
    }
  },
  components: {
    EditManager,
    ChargeAgent
  },
  filters: {
    timeChange: function (value) {
      if (!value) {
        return "";
      }
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;

      let d = date.getDate();
      d = d < 10 ? "0" + d : d;

      let h = date.getHours();
      h = h < 10 ? "0" + h : h;

      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;

      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;

      return y + "-" + MM + "-" + d + " " + h + ":" + m;
    },
    statusChange: function (value) {
      if (value == 1) {
        return "禁用";
      } else {
        return "恢复";
      }
    }
  },
  methods: {
    showAddAgent: function() {
      this.add_agent = !this.add_agent;
    },
    showEditAgent: function(index) {
      this.edit_agent = !this.edit_agent;
      this.uid = this.list[index].uid;
    },
    resetAgent: function() {
      this.add_agent = false;
      this.edit_agent = false;
      this.charge_agent = false;
    },
    showChargeAgent: function (index) {
      this.charge_agent = true;
      this.balance = this.list[index].balance;
      this.uid = this.list[index].uid;
    },
    editChange: function(type) {
      this.page = 0;
      let postdata = {
        task: "GET_AGENT_LIST",
        from: this.page * 15,
        to: (this.page + 1) * 15
      }
      let that = this;
      that.post("manager", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.list = data.data;
            if (type == "UPDATE_AGENT_DETAIL") {
              that.edit_agent = !that.edit_agent;
            }
            if (type == "ADD_AGENT") {
              that.add_agent = !that.add_agent;
            }
            if (type == "CHARGE_FOR_AGENT") {
              that.charge_agent = !that.charge_agent;
            }
            that.page += 1;
          }
        }).catch(function (e) {
      });
    },
    changeAgentStatus: function(index) {
      let status = this.list[index].status;
      let postdata = {
        uid: this.list[index].uid,
        task: "CHANGE_AGENT_STATUS"
      }
      let that = this;
      that.post("manager", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            let item = that.list[index];
            item["status"] = item["status"] == 1 ? 0:1;
            that.$set(that.list, index, item);
          } else {
            that.$message.error("修改失败");
          }
        }).catch(function (e) {
          console.log(e);
          that.$message.error("修改失败");
      });
    },
    loadMore: function() {
      let postdata = {
        task: "GET_AGENT_LIST",
        agent_name: this.$store.getters.getAgentName(),
        from: this.page * 15,
        to: (this.page + 1) * 15
      }
      let that = this;
      that.post("manager", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            if (data.data.length == 0) {
              that.$message.success("没有更多数据了");
            } else {
              for(let i = 0; i < data.data.length; i++) {
                that.list.push(data.data[i]);
              }
              that.page += 1;
            }
          }
        }).catch(function (e) {
      });
    }
  },
  created() {
    let postdata = {
      task: "GET_AGENT_LIST",
      agent_name: this.$store.getters.getAgentName(),
      from: this.page * 15,
      to: (this.page + 1) * 15
    }
    let that = this;
    that.post("manager", postdata)
      .then(function(data) {
        if (data.ret == 200) {
          that.list = data.data;
          that.page += 1;
        }
      }).catch(function (e) {
    });

    let deviceWidth = document.body.clientWidth
    if (deviceWidth >= 576) {
      this.modalWidth = "570px"; 
    }
  }
}
</script>

<style scoped>
  .content-container {
    border-bottom: 1px solid #e1e4e8;
    border-left: 1px solid #e1e4e8;
    border-right: 1px solid #e1e4e8;
  }
  .content-item {
    border-top: 1px solid #e1e4e8;
    padding: 8px;
  }
  .content-item:hover {
    background-color: #e6f7ff;
    cursor: pointer;
  }
</style>

